import { FaRegSave, FaShare } from "react-icons/fa";
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useSelector } from 'react-redux'
import { useEffect } from "react";
import { useDispatch } from 'react-redux'
import { ModalWrapper } from "./styled"
import { newsCategoriesSelector } from 'redux/selector'
import ShowToast from 'utils/ShowToast'
import { newsCategoriesActions } from 'redux/slice/newsCategoriesSlice'
import ButtonIcon from "components/ButtonIcon";
import { newsCategoryError } from "errors/newsCategoryError"
import Label from "components/Label";
import Input from "components/Input";

const Modal = ({ selectedId, showModal, hidden, method, currentPage, setCurrentPage }) => {
    const newsCategoriesState = useSelector(newsCategoriesSelector)
    const dispatch = useDispatch()

    let title = ''
    if (method === 'add') {
        title = 'Thêm mới loại bài viết'
    }
    if (method === 'update') {
        title = 'Cập nhật loại bài viết'
    }
    if (method === 'remove') {
        title = 'Xóa loại bài viết'
    }

    const formData = useFormik({
        initialValues: {
            id: "",
            name: "",
            slug: "",
            created_at: "",
            updated_at: "",
        },
        validateOnBlur: false,
        validateOnChange: false,
        validationSchema: Yup.object({
            name: Yup.string().trim().required(newsCategoryError.requiredName),
        }),
        onSubmit: (values, { setFieldError }) => {
            if (method === 'add') {
                if (newsCategoriesState.isFetching === false) {
                    const payload = {
                        name: values.name
                    }
                    dispatch(newsCategoriesActions.addNewsCategories({ setFieldError, data: payload, currentPage, ShowToast, hidden, handleSetDefaultForm }))
                }
            }
            if (method === 'update') {
                if (newsCategoriesState.isFetching === false) {
                    const payload = {
                        name: values.name
                    }
                    dispatch(newsCategoriesActions.updateNewsCategories({ setFieldError, id: values.id, data: payload, currentPage, ShowToast, hidden, handleSetDefaultForm }))
                }
            }
            if (method === 'remove') {
                if (newsCategoriesState.isFetching === false) {

                    dispatch(newsCategoriesActions.removeNewsCategories({ id: values.id, ShowToast, currentPage, setCurrentPage }))

                    handleSetDefaultForm()
                    hidden()
                }
            }
        }
    })
    function handleSetDefaultForm() {
        formData.setValues({
            id: "",
            name: "",
            slug: "",
            created_at: "",
            updated_at: "",
        })
        formData.setTouched({}, false);
        formData.setErrors({})
    }

    const handleCloseModal = () => {
        handleSetDefaultForm()
        hidden()
    }

    useEffect(() => {

        if (selectedId !== null) {
            const data = newsCategoriesState.newsCategoriesList.filter(item => item.id === selectedId)

            formData.setValues({
                ...data[0]
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedId, showModal, newsCategoriesState.newsCategoriesList])


    return (
        <ModalWrapper>
            <div className="mda">
                <div className='mda_overlay'
                    onClick={handleCloseModal}
                    style={
                        showModal ? {
                            transform: 'translateY(0%)',
                            opacity: 1
                        } : {
                            transform: 'translateY(-120%)',
                            opacity: 0
                        }
                    }
                ></div>
                <div className='mda_container p-40'
                    style={
                        showModal ? {
                            transform: 'translateY(0%)',
                            opacity: 1
                        } : {
                            transform: 'translateY(-120%)',
                            opacity: 0
                        }
                    }
                >
                    <h3 className='mda_header pb-15'>{title}</h3>
                    <form className='mda_body' onSubmit={formData.handleSubmit}>
                        <ul className='mda_body_list'>
                            {
                                method !== 'add' &&
                                <li className='mda_body_item'>
                                    <div className='mda_body_item_group'>
                                        <Label className="mb-5">Mã loại bài viết:</Label>
                                        <Input
                                            id='mda_body_input_id'
                                            placeholder='Nhập mã loại bài viết...'
                                            name="id"
                                            readOnly={true}
                                            value={formData.values.id}
                                        />
                                    </div>
                                </li>
                            }
                            <li className='mda_body_item'>
                                <div className='mda_body_item_group'>
                                    <Label className="mb-5">Tên loại bài viết:</Label>
                                    <Input
                                        id='mda_body_input_name'
                                        placeholder='Nhập tên loại bài viết...'
                                        name="name"
                                        readOnly={(method === 'show' || method === 'remove') ? true : false}
                                        value={formData.values.name}
                                        isError={!!formData.errors.name}
                                        message={formData.errors.name}
                                        onChange={formData.handleChange}
                                    />
                                </div>
                            </li>
                            {
                                method !== 'add' &&
                                <li className='mda_body_item'>
                                    <div className='mda_body_item_group'>
                                        <Label className="mb-5">Ngày tạo:</Label>
                                        <Input
                                            id='mda_body_input_created_at'
                                            type='date'
                                            name="created_at"
                                            readOnly={true}
                                            value={formData.values.created_at}
                                        />
                                    </div>
                                </li>
                            }
                        </ul>
                        <div className="mda_body_control">
                            {
                                method === 'add' &&
                                <ButtonIcon
                                    classButton="action-danger-1"
                                    icon={<FaRegSave />}
                                    isNa={newsCategoriesState.isFetching}
                                    type="submit"
                                >
                                    Thêm mới
                                </ButtonIcon>
                            }
                            {
                                method === 'update' &&
                                <ButtonIcon
                                    classButton="action-danger-1"
                                    icon={<FaRegSave />}
                                    isNa={newsCategoriesState.isFetching}
                                    type="submit"
                                >
                                    Cập nhật
                                </ButtonIcon>
                            }

                            {
                                method === 'remove' &&
                                <ButtonIcon
                                    classButton="action-danger-1"
                                    icon={<FaRegSave />}
                                    isNa={newsCategoriesState.isFetching}
                                    type="submit"
                                >
                                    Xóa

                                </ButtonIcon>

                            }
                            <ButtonIcon
                                classButton="action-primary"
                                icon={<FaShare />}
                                type="button"
                                onClick={handleCloseModal}
                            >
                                Thoát
                            </ButtonIcon>

                        </div>
                    </form>
                </div>
            </div>
        </ModalWrapper>
    );
}

export default Modal;